<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <div class="header-content">
      {{ 'VEHICLES.EDIT_MODAL.TITLE' | translate }}
    </div>
    <span class="ui-icon-close c-p" (click)="close()"></span>
  </div>

  <div class="body">
    <div class="form-field">
      <label class="form-label">{{ 'VEHICLES.TABLE.LICENCE_PLATE' | translate }}</label>
      <input
        type="text"
        class="ui-input"
        [(ngModel)]="editableVehicle().plate"
        [disabled]="true"
      />
    </div>

    <div class="form-field">
      <label class="form-label">{{ 'VEHICLES.TABLE.OWNER' | translate }}</label>
      <input
        type="text"
        class="ui-input"
        [(ngModel)]="editableVehicle().owner"
      />
    </div>

    <div class="form-field">
      <label class="form-label">{{ 'VEHICLES.TABLE.MAKE' | translate }}</label>
      <input
        type="text"
        class="ui-input"
        [(ngModel)]="editableVehicle().make"
      />
    </div>

    <div class="form-field">
      <label class="form-label">{{ 'VEHICLES.TABLE.COLOR' | translate }}</label>
      <mat-select class="ui-selector" [formControl]="colorControl">
        <mat-select-trigger>
          @if (colorControl.value) {
            <div class="color-option-display">
              <span
                class="color-swatch selected-trigger"
                [style.--swatch-color]="colorControl.value.hex"
                [style.background-color]="colorControl.value.hex"
              ></span>
              <span>{{ colorControl.value.name | translate }}</span>
            </div>
          }
        </mat-select-trigger>

        @for (color of vehicleColorOptions; track color.hex) {
          <mat-option [value]="color" [class.selected]="colorControl.value?.hex === color.hex">
            <div class="color-option-display">
              <span
                class="color-swatch"
                [class.has-stroke]="color['strokeHex']"
                [style.--swatch-color]="color.hex"
                [style.background-color]="color.hex"
                [style.border-color]="color['strokeHex']"
              ></span>
              <span>{{ color.name | translate }}</span>
            </div>
          </mat-option>
        }
      </mat-select>
    </div>
  </div>

  <div class="footer">
    <ui-button
      type="secondary"
      [text]="'COMMON.CANCEL' | translate"
      (clickAction)="onCancel()"
    ></ui-button>
    <ui-button
      type="primary"
      [text]="'COMMON.SAVE' | translate"
      (clickAction)="onSave()"
    ></ui-button>
  </div>
</div>
